import { useNavigate } from "react-router-dom";
import { ItemsList } from "../../../common/components/itemsList/ItemsList";
import { useAddAdditionalLayoutButton } from "../../../common/infrastructure/hooks/useAddAdditionalLayoutButton";
import { useApiQuery } from "../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import {
  constructSupportChatHref,
  routePaths,
} from "../../../common/infrastructure/routes/routePaths";
import { IconType } from "../../../common/icons/Icon";
import { ISupportChatListItem } from "../models/supportChatModels";
import { SupportChatItem } from "./SupportChatItem";
import { useAppContext } from "../../../AppContext";
import { UserRole } from "../../../common/enums";
import { getCurrentUserRole } from "../../../common/infrastructure/helpers/userHelper";
import { EmptyState } from "../../../common/components/common/EmptyState/EmptyState";

export const SupportList = () => {
  const navigate = useNavigate();
  const { currentUser } = useAppContext();
  const isGlobalAdmin =
    getCurrentUserRole(currentUser) === UserRole.GlobalAdmin;

  useAddAdditionalLayoutButton({
    iconType: IconType.PlusIcon,
    href: routePaths.supportNew,
    validator: !isGlobalAdmin,
  });

  const { data: chats, isLoading } = useApiQuery<ISupportChatListItem[]>(
    {
      queryKey: [endpointsMetadata.supportChat.getAll],
      endpoint: endpointsMetadata.supportChat.getAll,
      globalIsLoading: false,
    },
    { refetchInterval: 10000 },
  );

  const itemOnClick = (id?: any) => {
    if (id) navigate(constructSupportChatHref(id as string));
  };

  const noItemsContent = isGlobalAdmin ? (
    "Няма намерени запитвания."
  ) : (
    <EmptyState
      icon={IconType.Information}
      title="Как можем да помогнем?"
      description="Тук можете да се свържете с нашия екип относно технически проблеми, заявки за нови функционалности, въпроси за плащания и други."
      actionLabel="Ново запитване"
      onAction={() => navigate(routePaths.supportNew)}
    />
  );

  return (
    <ItemsList
      itemOnClick={itemOnClick}
      isLoading={isLoading}
      title={isGlobalAdmin ? "Всички запитвания" : "Моите запитвания"}
      noItemsText={noItemsContent}
      itemTemplate={(item, index, _actionButtons, className) => (
        <SupportChatItem
          className={className}
          item={item}
          key={item?.id ?? index}
        />
      )}
      items={chats ?? []}
      enableSearch
      fullHeight
    />
  );
};
